var _defs, _rect, _path, _circle, _clipPath, _path2, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrazil(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 504,
    width: 720,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2100 -1470 4200 2940",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "D",
    fillRule: "evenodd",
    d: "m-31.5 0h33a30 30 0 0 0 30 -30v-10a30 30 0 0 0 -30 -30h-33zm13-13h19a19 19 0 0 0 19 -19v-6a19 19 0 0 0 -19 -19h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    transform: "translate(-31.5)",
    d: "m0 0h63v-13h-51v-18h40v-12h-40v-14h48v-13h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11h39.25v-12h-51.25z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-31.5 0v-70h63v70zm31.5-47v12h31.5v-12z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O",
    clipPath: "url(#gcut)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -35,
    x: 5,
    height: 10,
    width: 26.5
  }), /*#__PURE__*/React.createElement("rect", {
    y: -35,
    x: 21.5,
    height: 35,
    width: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "m-31.5 0h12v-48l14 48h11l14-48v48h12v-70h-17.5l-14 48-14-48h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    fillRule: "evenodd",
    d: "m0 0a31.5 35 0 0 0 0 -70 31.5 35 0 0 0 0 70m0-13a18.5 22 0 0 0 0 -44 18.5 22 0 0 0 0 44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    fillRule: "evenodd",
    d: "m-31.5 0h13v-26h28a22 22 0 0 0 0 -44h-40zm13-39h27a9 9 0 0 0 0 -18h-27z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 0c0-10 0-32-15-32h-19c22 0 22 22 22 32"
  })), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "m-15.75-22c0 7 6.75 10.5 16.75 10.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25 0.25-21.5 24.75-20.5 33.75-20.5s26 4 25.75 21.25h-15.25c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-0.25 11.75 46.25 4 46.25 28.75 0 18.25-18 21.75-31.5 21.75-11.5 0-31.55-4.5-31.5-22z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "star",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    transform: "rotate(18 0,-1)",
    d: "m0-1v1h0.5"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(-72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(216)"
  })), /*#__PURE__*/React.createElement("use", {
    id: "star1",
    xlinkHref: "#star",
    transform: "scale(31.5)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star2",
    xlinkHref: "#star",
    transform: "scale(26.25)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star3",
    xlinkHref: "#star",
    transform: "scale(21)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star4",
    xlinkHref: "#star",
    transform: "scale(15)"
  }), /*#__PURE__*/React.createElement("use", {
    id: "star5",
    xlinkHref: "#star",
    transform: "scale(10.5)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: "-50%",
    x: "-50%",
    height: "100%",
    fill: "#009b3a",
    width: "100%"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1743 0 1743 1113 1743-1113-1743-1113z",
    fill: "#fedf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#002776"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "band"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0 -3360 0z",
    clipPath: "url(#band)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420,1470)",
    fill: "#009b3a"
  }, /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(-7)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(-4)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#D",
    transform: "rotate(-1)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#E",
    transform: "rotate(2)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#M",
    transform: "rotate(5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#e",
    transform: "rotate(9.75)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#P",
    transform: "rotate(14.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(17.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(20.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#G",
    transform: "rotate(23.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#R",
    transform: "rotate(26.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#E",
    transform: "rotate(29.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#S",
    transform: "rotate(32.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#S",
    transform: "rotate(35.5)"
  }), /*#__PURE__*/React.createElement("use", {
    y: -1697.5,
    xlinkHref: "#O",
    transform: "rotate(38.5)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMi",
    y: -132,
    x: -600,
    xlinkHref: "#star1"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMa",
    y: 177,
    x: -535,
    xlinkHref: "#star1"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2CMa",
    y: 243,
    x: -625,
    xlinkHref: "#star2"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3CMa",
    y: 132,
    x: -463,
    xlinkHref: "#star4"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4CMa",
    y: 250,
    x: -382,
    xlinkHref: "#star2"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5CMa",
    y: 323,
    x: -404,
    xlinkHref: "#star3"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Vir",
    y: -228,
    x: 228,
    xlinkHref: "#star1"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Sco",
    y: 258,
    x: 515,
    xlinkHref: "#star1"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Sco",
    y: 265,
    x: 617,
    xlinkHref: "#star3"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Sco",
    y: 323,
    x: 545,
    xlinkHref: "#star2"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B8Sco",
    y: 477,
    x: 368,
    xlinkHref: "#star2"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B9Sco",
    y: 551,
    x: 367,
    xlinkHref: "#star3"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BASco",
    y: 419,
    x: 441,
    xlinkHref: "#star3"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BBSco",
    y: 382,
    x: 500,
    xlinkHref: "#star2"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BCSco",
    y: 405,
    x: 365,
    xlinkHref: "#star3"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Hya",
    y: 30,
    x: -280,
    xlinkHref: "#star2"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Hya",
    y: -37,
    x: 200,
    xlinkHref: "#star3"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Cru",
    y: 330,
    xlinkHref: "#star1"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Cru",
    y: 184,
    x: 85,
    xlinkHref: "#star2"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Cru",
    y: 118,
    xlinkHref: "#star2"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4Cru",
    y: 184,
    x: -74,
    xlinkHref: "#star3"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Cru",
    y: 235,
    x: -37,
    xlinkHref: "#star4"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1TrA",
    y: 495,
    x: 220,
    xlinkHref: "#star2"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2TrA",
    y: 430,
    x: 283,
    xlinkHref: "#star3"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3TrA",
    y: 412,
    x: 162,
    xlinkHref: "#star3"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Car",
    y: 390,
    x: -295,
    xlinkHref: "#star1"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03C3Oct",
    y: 575,
    xlinkHref: "#star5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };